export default {
  page: {
    title: 'Fund Details',
  },
  tabs: {
    deposit: 'Deposit Details',
    withdraw: 'Withdrawal Details',
    bonus: 'Bonus Details',
  },
  filter: {
    keywordPlaceholder: 'Search by Member ID, Nickname, Order ID, Parent ID',
    status: 'Status',
    country: 'Country of Residence',
    applyTime: 'Apply Time',
    payTime: 'Payment Time',
    auditTime: 'Audit Time',
    search: 'Search',
    reset: 'Reset',
  },
  table: {
    columns: {
      memberId: 'Member ID',
      nickname: 'Nickname',
      orderId: 'Order ID',
      country: 'Country',
      registerTime: 'Register Time',
      parentId: 'Parent ID',
      depositAmount: 'Deposit Amount',
      withdrawAmount: 'Withdrawal Amount',
      bonusRule: 'Bonus Rule',
      bonusAmount: 'Bonus Amount',
      status: 'Status',
      applyTime: 'Apply Time',
      payTime: 'Payment Time',
      auditTime: 'Audit Time',
      mtAccount: 'MT Account',
    },
  },
  statusText: {
    deposit: {
      done: 'Deposit Completed',
      pending: 'Processing',
      failed: 'Deposit Failed',
    },
    withdraw: {
      done: 'Withdrawal Completed',
      pending: 'Processing',
      failed: 'Withdrawal Failed',
    },
    bonus: {
      done: 'Bonus Completed',
      failed: 'Bonus Failed',
    },
    options: {
      done: 'Done',
      pending: 'Pending',
      failed: 'Failed',
    },
  },
}
